export function initHeaderMenu() {
	const nav = document.querySelector(".js-navigation-primary");
	if (!nav) return;

	const allTriggers = nav.querySelectorAll("[data-menu-index]");

	allTriggers.forEach((triggerItem) => {
		const index = triggerItem.getAttribute("data-menu-index");
		const link = triggerItem.querySelector("a");
		const level = triggerItem.closest("[data-level]")?.dataset.level || "1";
		const submenuTarget = nav.querySelector(
			`[data-submenu-index="${index}"]`
		);

		if (!submenuTarget || !link) return;

		triggerItem.dataset.level = level;
		submenuTarget.dataset.level = `${parseInt(level) + 1}`;

		// Trova la freccia ovunque nel triggerItem
		const arrow = triggerItem.querySelector(".js-navigation-arrow");

		// Verifica se la freccia è dentro al <a> (caso Magazine)
		const arrowInsideLink = arrow && link.contains(arrow);

		const activateSubmenu = (event) => {
			event.preventDefault();
			event.stopPropagation();

			const isActive =
				submenuTarget.classList.contains("submenu--active");

			if (!isActive) {
				if (level === "1") {
					nav.querySelectorAll(".submenu--active").forEach((el) =>
						el.classList.remove("submenu--active")
					);
					nav.querySelectorAll(".menu-item-is-active").forEach((el) =>
						el.classList.remove("menu-item-is-active")
					);
				}

				submenuTarget.classList.add("submenu--active");
				triggerItem.classList.add("menu-item-is-active");
				arrow?.setAttribute?.("aria-expanded", "true");
				document.documentElement.classList.add(
					"is-navigation-primary-active"
				);
			} else {
				submenuTarget.classList.remove("submenu--active");
				triggerItem.classList.remove("menu-item-is-active");
				arrow?.setAttribute?.("aria-expanded", "false");

				const anyOpen = nav.querySelector(".submenu--active");
				if (!anyOpen) {
					document.documentElement.classList.remove(
						"is-navigation-primary-active"
					);
				}
			}
		};

		// --- Comportamento corretto condizionato
		if (arrow && arrowInsideLink) {
			// ✅ Caso Magazine: freccia DENTRO il link
			// La freccia è trigger, il link va alla pagina
			arrow.setAttribute("role", "button");
			arrow.setAttribute("tabindex", "0");
			arrow.setAttribute("aria-expanded", "false");
			arrow.setAttribute("aria-haspopup", "true");

			arrow.addEventListener("click", activateSubmenu);

			arrow.addEventListener("keydown", (event) => {
				if (event.key === "Enter" || event.key === " ") {
					event.preventDefault();
					activateSubmenu(event);

					const firstSubLink = submenuTarget.querySelector("a");
					firstSubLink?.focus();
				}
			});
		} else {
			// ✅ Tutti gli altri casi: il <a> apre il submenu
			link.addEventListener("click", (event) => {
				if (submenuTarget) {
					activateSubmenu(event);
				}
			});

			link.addEventListener("keydown", (event) => {
				if (
					(event.key === "Enter" || event.key === " ") &&
					submenuTarget
				) {
					event.preventDefault();
					activateSubmenu(event);

					const firstSubLink = submenuTarget.querySelector("a");
					firstSubLink?.focus();
				}
			});
		}

		// Pulsante di chiusura
		const closeBtn = submenuTarget.querySelector(".js-submenu-close");
		if (closeBtn) {
			closeBtn.addEventListener("click", () => {
				submenuTarget.classList.remove("submenu--active");
				triggerItem.classList.remove("menu-item-is-active");
				arrow?.setAttribute?.("aria-expanded", "false");

				const anyOpen = nav.querySelector(".submenu--active");
				if (!anyOpen) {
					document.documentElement.classList.remove(
						"is-navigation-primary-active"
					);
				}
			});
		}
	});

	// Click fuori chiude tutto
	document.addEventListener("click", (event) => {
		if (!nav.contains(event.target)) {
			nav.querySelectorAll(".submenu--active").forEach((el) =>
				el.classList.remove("submenu--active")
			);
			nav.querySelectorAll(".menu-item-is-active").forEach((el) =>
				el.classList.remove("menu-item-is-active")
			);
			document.documentElement.classList.remove(
				"is-navigation-primary-active"
			);
		}
	});

	// ESC chiude tutto
	document.addEventListener("keydown", (event) => {
		if (event.key === "Escape") {
			nav.querySelectorAll(".submenu--active").forEach((el) =>
				el.classList.remove("submenu--active")
			);
			nav.querySelectorAll(".menu-item-is-active").forEach((el) =>
				el.classList.remove("menu-item-is-active")
			);
			document.documentElement.classList.remove(
				"is-navigation-primary-active"
			);
		}
	});
}
